import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxModalUpsellComponent } from './phx-modal-upsell.component';
import { PhxModalUpsellSuccessIconComponent } from './phx-modal-upsell-success-icon.component';
import { PhxDialogModule } from '../dialog/phx-dialog.module';
import { PhxButtonUpsellModule } from '../button-upsell/phx-button-upsell.module';

@NgModule({
  declarations: [PhxModalUpsellComponent, PhxModalUpsellSuccessIconComponent],
  imports: [CommonModule, PhxDialogModule, PhxButtonUpsellModule],
  exports: [PhxModalUpsellComponent],
})
export class PhxModalUpsellModule {}
